import NextImage from '@/components/NextImage';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';

export default function Balcony() {
    const { useLang, useState, useRouter, useEffect, Link } = useGlobal();
    const { t } = useLang('powerstream.detail.balcony');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);
    const cardsAll: any = [
        {
            subtitle: t('card1_subtitle'),
            title: t('card1_title'),
            desc: t('card1_desc'),
            link: t('card1_link'),
            price: t('card1_price'),
            original: t('card1_original'),
            img: require('@publicLocal/power-stream/detail/pc/balcony_1.jpg'),
            productId: '8633212993871',
            variantId: '47045696160079',
        },
        {
            subtitle: t('card4_subtitle'),
            title: t('card4_title'),
            desc: t('card4_desc'),
            link: t('card4_link'),
            price: t('card4_price'),
            original: t('card4_original'),
            img: require('@publicLocal/power-stream/detail/pc/balcony_2.jpg'),
            productId: '8633181536591',
            variantId: '47045458624847',
        },
        {
            subtitle: t('card3_subtitle'),
            title: t('card3_title'),
            desc: t('card3_desc'),
            link: t('card3_link'),
            price: t('card3_price'),
            original: t('card3_original'),
            img: require('@publicLocal/power-stream/detail/pc/balcony_3.jpg'),
            productId: '8633163415887',
            variantId: '47045281022287',
        },
        {
            subtitle: t('card2_subtitle'),
            title: t('card2_title'),
            desc: t('card2_desc'),
            link: t('card2_link'),
            price: t('card2_price'),
            original: t('card2_original'),
            img: require('@publicLocal/power-stream/detail/pc/balcony_4.jpg'),
            productId: '8633184190799',
            variantId: '47045511053647',
        },
    ];

    const [cards, setCards] = useState(cardsAll);

    useEffect(() => {
        const tempArr = [...cardsAll.filter((card: any) => card?.variantId)];
        const otherArr = [...cardsAll.filter((card: any) => !card?.variantId)];
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        tempArr[k].discountPrice = res?.data?.price;
                        tempArr[k].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                        tempArr[k].inventory = res?.data?.inventoryQuantity ?? undefined;
                        tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${tempArr[k].variantId}:1?channel=buy_button`;
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then(() => {
                setCards([...tempArr, ...otherArr]);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div className={`balcony ${css.balcony}`}>
            <div className="text-box">
                <p className="title">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
            </div>
            <div className="content-box">
                <div className="thumb-box">
                    {cards?.map((card: any, k: number) => (
                        <div className={`thumb-item ${k === active ? 'active' : ''}`} key={k} onClick={() => setActive(k)}>
                            <NextImage src={card?.img} alt={card?.title} aria-label={card?.label} />
                            <p className="thumb-title">{card?.title}</p>
                        </div>
                    ))}
                </div>
                <div className="img-box">
                    <NextImage src={cards[active]?.img} alt={cards[active]?.title} aria-label={cards[active]?.label} />
                    {/* <div className="small-card">
                        <p className="card-subtitle">{cards[active]?.subtitle}</p>
                        <p className="card-title">{cards[active]?.title}</p>
                        <p className="card-desc">{cards[active]?.desc}</p>
                        <div className="card-box">
                            <div className="left-price">
                                <span className="price">
                                    {cards[active]?.discountPrice ? FormatMoneyLocal(cards[active]?.discountPrice, locale) : cards[active]?.price}
                                </span>
                                <span className="original">
                                    {cards[active]?.originalPrice ? FormatMoneyLocal(cards[active]?.originalPrice, locale) : cards[active]?.original}
                                </span>
                            </div>
                            <Link href={cards[active]?.link} className="card-link">
                                {t('buy_now')}
                            </Link>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
}
